module.exports = __webpack_public_path__ + "img/teacher_01.a93e3b46.png";